/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { Props as SelectProps, GroupBase } from 'react-select';
import { FiAlertCircle } from 'react-icons/fi';
import { useField } from '@unform/core';

import { Container, CustomSelect, Error } from './styles';

interface Props extends SelectProps<any, boolean, GroupBase<any>> {
  name: string;
  isMulti?: boolean;
}

const Select: React.FC<Props> = ({ name, ...rest }) => {
  const selectRef = useRef<any>(null);
  const [isFocused, setIsFocused] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef,
      getValue: (ref: any) => {
        const { current } = ref;
        if (!current || !current.getValue) return rest.isMulti ? [] : null;
        const selected = current.getValue();
        if (rest.isMulti) {
          return selected ? selected.map((option: any) => option.value) : [];
        }
        return selected && selected.length > 0 ? selected[0].value : null;
      },
      setValue: (ref: any, value: any) => {
        const { current } = ref;
        if (!current || !current.setValue) {
          console.warn(`Select (${fieldName}) não está pronto para setValue`);
          return;
        }
        const options = rest.options || [];
        if (rest.isMulti) {
          const selected = Array.isArray(value)
            ? options.filter((option: any) => value.includes(option.value))
            : [];
          current.setValue(selected);
        } else {
          const selected = value
            ? options.find((option: any) => option.value === value.value) ||
              value
            : null;
          current.setValue(selected);
        }
      },
    });
  }, [fieldName, registerField, rest.isMulti, rest.options]);

  return (
    <Container $isErrored={!!error} $isFocused={isFocused}>
      <CustomSelect
        defaultValue={defaultValue}
        ref={selectRef}
        classNamePrefix="react-select"
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        {...rest}
      />

      {error && (
        <Error title={error} content={error}>
          <FiAlertCircle color="#c53030" size={20} />
        </Error>
      )}
    </Container>
  );
};

export default Select;
